import { getAPI, postAPI, putAPI } from "../../api/api";
import { REACT_APP_CANDIDATE, REACT_APP_CANDIDATE_FRELLANCER, REACT_APP_CUSTOMER, REACT_APP_JOB, REACT_APP_PROFILE, REACT_APP_RECRUITER } from "../../utils/common";


export async function getDetails(Id: string | null){
    const Details = getAPI( REACT_APP_CANDIDATE  + `/candidates/${Id}`)
    return Details
}

export async function submitDetails(data: any){
    const Details = postAPI( REACT_APP_CANDIDATE_FRELLANCER + `/updateprofile`, data)
    return Details
}

export async function submitResume(data: any, id: string | null){
    const Resume = postAPI(  REACT_APP_PROFILE + `/api/extractResumeDetails/${id}`, data)
    return Resume
}

export async function updateProfiles(data: any){
    const Resume = putAPI(REACT_APP_CANDIDATE + '/candidates', data)
    return Resume
}

export async function extractResume(data: any){
    const Resume = postAPI( REACT_APP_PROFILE + '/resume-details-ext', data)
    return Resume
}

export async function submitProfile(data: any){
    const Resume = postAPI( REACT_APP_CANDIDATE_FRELLANCER + `/updatecandidatestatus`, data)
    return Resume
}

export async function getProviderResources(){
    const Details = getAPI( REACT_APP_CUSTOMER + '/getProviderResources')
    return Details
}

export async function getRecruiterResources(){
    const Details = getAPI( REACT_APP_RECRUITER + '/list')
    return Details
}

export async function getPositionDetails(candidateId: any) {
    const Details = getAPI(REACT_APP_JOB + `/getPositionDetails?candidateId=${candidateId}`)
    return Details
}

export async function sendCredentails(body: any) {
    const Details = postAPI( REACT_APP_CANDIDATE_FRELLANCER + `/sendCredentialsEmail`, body)
    return Details
}

export async function getIncontractCompany(loginId: string) {
    const  Details = getAPI(REACT_APP_JOB + `/incontract-companies/${loginId}`)
    return Details

}

export async function getJobDetails(jobId: string, loginId: string) {
    const Details = getAPI(REACT_APP_JOB + `/getInContractJobDetails/${jobId}?loginId=${loginId}`)
    return Details
}

export async function requestCompanyRating(body: any) {
    const Details = postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/saveAssessmentRequestDetails', body)
    return Details
}

export async function getHistory(loginId: string, userLoginId: string) {
    const Details = getAPI(REACT_APP_CANDIDATE_FRELLANCER + `/getAssessmentRequestHistory/${loginId}?userloginId=${userLoginId}`)
    return Details
}

export async function sendRatingReminder(body: any) {
    const Details = postAPI(REACT_APP_CANDIDATE_FRELLANCER + '/resendAssessmentRequest', body)
    return Details
}

export async function getQuestions() {
    const Details = getAPI(REACT_APP_CANDIDATE + '/getSurveyQuestions')
    return Details
}

export async function updateSurveyData(body: any) {
    const Details = postAPI(REACT_APP_CANDIDATE + '/updateSurveyData', body)
    return Details
}

export async function sentSureveyLinkEmail(body: any) {
    const Details = postAPI(REACT_APP_RECRUITER + '/ellowCareerSurveyEmail', body)
    return Details
    
}

export async function getHackerearthResult(loginId: string, skillId: number, url: string) {
    const Details = getAPI(REACT_APP_PROFILE + `/api/getHackerEarthTestResultPDF/${loginId}?skillId=${skillId}&Url=${url}`)
    return Details
}

export async function getComments(loginId: string) {
    const Details = getAPI(REACT_APP_CANDIDATE + `/getInsightComments/${loginId}`)
    return Details
}

export async function addInsightComments(body: any) {
    const Details = putAPI(REACT_APP_CANDIDATE + `/updateInsightComments`, body)
    return Details
}